import React from 'react';

// Shared card/panel primitive: white surface, rounded corners, soft shadow.
// Replaces the per-file cardStyle objects duplicated across the app. Pass
// `style` to override (e.g. padding) and any other div props pass through.
export default function Card({ style, children, ...rest }) {
  return (
    <div
      style={{
        background: 'var(--white)',
        borderRadius: 12,
        boxShadow: '0 1px 8px rgba(0,0,0,0.09)',
        padding: 16,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
